export const normalizer = (orderDetail, parentId) => {
  orderDetail.articleId = orderDetail.article?.id || orderDetail.articleId;
  orderDetail.orderId = orderDetail.orderId || parentId;
  orderDetail.quantity =
    orderDetail.quantity?.code || orderDetail.quantity || 1;
  return orderDetail;
};
